import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';
import { Event, NavigationEnd, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { filter, tap } from 'rxjs/operators';

import * as FormActions from '@shared/form/store/form.actions';

import { CandidateFormComponent } from './candidate-form.container';

@Component({
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CandidateFormModalComponent implements OnDestroy {
  subscription: Subscription;

  constructor(private store: Store<{}>, private router: Router) {
    this.subscription = this.router.events
      .pipe(
        filter((event: Event) => event instanceof NavigationEnd),
        filter((event: NavigationEnd) =>
          event.urlAfterRedirects.includes('(modal:candidateForm')
        ),
        tap(() =>
          this.store.dispatch(
            FormActions.formOpen({
              formState: {
                component: CandidateFormComponent,
                data: {
                  panelClass: 'large-size-modal',
                  header: 'Edit profile'
                }
              }
            })
          )
        )
      )
      .subscribe();
  }

  ngOnDestroy() {
    return !!this.subscription && this.subscription.unsubscribe();
  }
}
